import React, { useState } from 'react'
import { Modal, ModalBody, Input, Button, Label } from 'reactstrap'
import { Check } from 'phosphor-react'
import * as S from './styles'

const PasswordModal = (props) => {
  const { isOpen, toggle, callback } = props

  const [password, setPassword] = useState('')
  const [passwordBis, setPasswordBis] = useState('')
  const [hasUppercase, setHasUppercase] = useState(null)
  const [hasLowercase, setHasLowercase] = useState(null)
  const [hasNumber, setHasNumber] = useState(null)
  const [hasNoSpaceOrSpecial, setHasNoSpaceOrSpecial] = useState(null)

  const checkNumber = (myString) => /\d/.test(myString)
  const checkUppercase = (myString) => /[A-Z]/.test(myString)
  const checkLowercase = (myString) => /[a-z]/.test(myString)
  const checkNoSpaceOrSpecial = (myString) =>
    !/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(myString)

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
    setHasNumber(checkNumber(e.target.value))
    setHasUppercase(checkUppercase(e.target.value))
    setHasLowercase(checkLowercase(e.target.value))
    setHasNoSpaceOrSpecial(checkNoSpaceOrSpecial(e.target.value))
  }

  const handleUpdatePassword = () => {
    callback(password)
    toggle()
  }

  const isPasswordStrong =
    hasUppercase &&
    hasLowercase &&
    hasNumber &&
    hasNoSpaceOrSpecial &&
    password.length > 7 &&
    password.length < 16

  return (
    <Modal isOpen={isOpen} toggle={() => {}}>
      <ModalBody>
        <form>
          <span>
            Un compte candidat va vous être créé pour y suivre vos différentes
            candidatures, veuillez sélectionner votre mot de passe
          </span>
          <S.PasswordUpdate>
            <div className="password-rules-list">
              <div
                className="check-tag"
                {...(password.length > 7 &&
                  password.length < 16 && {
                    style: {
                      color: '#4B997C',
                      backgroundColor: '#D8F6ED',
                    },
                  })}
              >
                <Check size={20} /> Entre 8 et 15 caractères
              </div>
              <div
                className="check-tag"
                {...(hasUppercase === true && {
                  style: {
                    color: '#4B997C',
                    backgroundColor: '#D8F6ED',
                  },
                })}
              >
                <Check size={20} /> une majuscule
              </div>
              <div
                className="check-tag"
                {...(hasLowercase === true && {
                  style: {
                    color: '#4B997C',
                    backgroundColor: '#D8F6ED',
                  },
                })}
              >
                <Check size={20} /> une minuscule
              </div>
              <div
                className="check-tag"
                {...(hasNumber === true && {
                  style: {
                    color: '#4B997C',
                    backgroundColor: '#D8F6ED',
                  },
                })}
              >
                <Check size={20} /> un chiffre ou une ponctuation
              </div>
              <div
                className="check-tag"
                {...(hasNoSpaceOrSpecial === true && {
                  style: {
                    color: '#4B997C',
                    backgroundColor: '#D8F6ED',
                  },
                })}
              >
                <Check size={20} /> Pas d'espace ou de caractère spécial
              </div>
            </div>

            <Label for="password">
              <span style={{ color: 'red' }}>* </span>
              Nouveau mot de passe
              <Input
                autoComplete="off"
                type="password"
                name="password"
                value={password}
                onChange={handlePasswordChange}
                {...(isPasswordStrong && {
                  style: { borderColor: 'green' },
                })}
              />
            </Label>
            <Label for="passwordBis">
              <span style={{ color: 'red' }}>* </span>
              Répéter le mot de passe
              <Input
                autoComplete="off"
                type="password"
                name="passwordBis"
                value={passwordBis}
                onChange={(e) => setPasswordBis(e.target.value)}
              />
            </Label>

            <div className="button-container">
              <Button
                color="primary"
                onClick={handleUpdatePassword}
                disabled={!(isPasswordStrong && password === passwordBis)}
              >
                Valider le mot de passe
              </Button>
            </div>
          </S.PasswordUpdate>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default PasswordModal
